import { useContext, useMemo } from 'react';
import { EntitySecurityContext } from '../contexts/EntitySecurityContext';

/**
 * hook that returns a deduped dot notation path as a string value of entity names by looking up from the closest EntitySecurityProvider
 */
export function useEntitySecurityPath(): string {
    const entityContextValue = useContext(EntitySecurityContext);

    const entitySecurityPath = useMemo(() => {
        const entitySecurityContexts = entityContextValue?.entitySecurityContexts ?? [];
        const dedupedEntityNames = [...new Set(entitySecurityContexts.map(({ entityName }) => entityName))];
        /**
         * @todo
         * Currently the only entity name normalization logic is applying `toLocaleLowerCase()`.
         * This may need to be enhanced as we extend the deep link feature to other entities,
         * in case entity naming between the Security module and the DeepLink module have discrepancies.
         */
        const path = dedupedEntityNames.reverse().join('.').toLocaleLowerCase();
        return path;
    }, [entityContextValue?.entitySecurityContexts]);

    return entitySecurityPath;
}
